module.exports = __webpack_public_path__ + "static/baked_cheeseballs-39a2210ded01bb5c0d9085a5a3603e12.jpg";